import React, { useEffect, useCallback } from "react";
import Form from "react-bootstrap/Form";
import { SearchIcon } from "../Icons";
import debounce from "lodash.debounce";

const Search = ({ onSearch, searchTerm, setSearchTerm }) => {
  const debouncedSearch = useCallback(
    debounce((term) => {
      onSearch(term);
    }, 300),
    [onSearch]
  );

  useEffect(() => {
    return () => debouncedSearch.cancel();
  }, [debouncedSearch]);

  const handleChange = (event) => {
    const { value } = event.target;
    setSearchTerm(value);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      onSearch(searchTerm);
    }
  };

  return (
    <div className="search-wrap">
      <Form.Control
        type="text"
        placeholder="Search"
        value={searchTerm}
        onChange={handleChange}
        onKeyPress={handleKeyPress}
      />
      <div className="icon-wrap">
        <SearchIcon />
      </div>
    </div>
  );
};

export default Search;
